import { memo, useContext } from 'react';
import spacetime from 'spacetime';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';

import styles from './AgreementsCompletionDate.module.scss';

interface IAgreementsCompletionDateProps {
  id: string;
  isWatchOnly: boolean;
  name: string;
}

export const AgreementsCompletionDate = memo(({ id, isWatchOnly, name }: IAgreementsCompletionDateProps) => {
  const { isKnm, isPm, isDecision } = useContext(AgreementsContext);

  return (
    <FieldBlock
      label={getTitleFieldWithRedStar({
        label: 'Срок исполнения соглашения',
        field: `${name}.termOfExecutionAgreement`,
        isKnm,
        isPm,
        isDecision,
      })}
      className={styles.Wrapper}
      id={`${id}.termOfExecutionAgreement`}
    >
      <DatePickerField
        name={`${name}.termOfExecutionAgreement`}
        placeholder={'Срок исполнения'}
        size="medium"
        disabled={isWatchOnly}
        minDate={new Date()}
        maxDate={spacetime().add(3, 'years').toNativeDate()}
      />
    </FieldBlock>
  );
});
